import React from "react"
import { IoCloseCircleOutline } from "@react-icons/all-files/io5/IoCloseCircleOutline"

export default function AboutModal(props) {
  // close the modal
  const closeModal = () => {
    if (typeof document !== `undefined`) {
        let modal = document.querySelector('.modal_background');
        modal.style.display = 'none'
    }
  }
  
  return (
    <div
      className="absolute z-10 h-screen w-full backdrop-blur-sm font-jb modal_background"
      style={{ backgroundColor: "rgba(0,0,0,0.3)", transition: 'all 2.5s ease', display: 'none', overflow: 'none' }}
    >

        <div className="flex justify-center items-center w-full h-screen">
        <div
        className="h-2/3 w-10/12 rounded-lg bg-white z-20 p-3 overflow-y-scroll text-gray-600 lg:w-5/12"
      >
        <div className="h-5/6 overflow-y-scroll">
          <div className="text-lg font-semibold text-gray-600 mb-2">
            How to use
          </div>
          <div>
            Write{" "}
            <span className="font-semibold text-gray-600">ShonaScript</span>{" "}
            code in the white text box, then hit the round{" "}
            <span className="font-semibold text-gray-600">play</span> at the
            bottom. You will see a white box with the results of your code run
          </div>
          <hr className="mt-3 w-2/12 mx-auto" />
          <div className="text-lg font-semibold text-gray-600 mb-2">About</div>
          <div>
            <span className="font-semibold text-gray-600">
              ShonaScript Programming language
            </span>{" "}
            was created to help people learn coding easier and more fun using
            Shona language.
          </div>
          <hr className="mt-3 w-2/12 mx-auto" />
          <div className="text-lg font-semibold text-gray-600 mb-2">
            Website
          </div>
          <a href="https://shonascript.org" className="text-shona">shonascript.org</a>
          <hr className="mt-3 w-2/12 mx-auto" />
          <div className="text-lg font-semibold text-gray-600 mb-2">
            Whatsapp Groups
          </div>
          <div>
            <a href="https://chat.whatsapp.com/Hh3ZBY9Me3xJLSt89zybkR" className="text-shona">beginners group</a>
          </div>
          <div>
            <a href="https://chat.whatsapp.com/JojyVCqOQn5Ac5HUNV0kE8" className="text-shona">contributors group</a>
          </div>
          <hr className="mt-3 w-2/12 mx-auto" />
          <div className="text-lg font-semibold text-gray-600 mb-2">
            Developer
          </div>
          <div>
            <a href="mailto:panashemuriro2021@gmail.com" className="text-shona">Panashe Muriro</a>
          </div>
        </div>
        <div className="h-1/6 flex items-center justify-center">
          <div
            className="bg-red-600 text-white inline-block p-3 rounded-full text-3xl"
            onClick={closeModal}
          >
            <IoCloseCircleOutline />
          </div>
        </div>
      </div>
        </div>
 
    </div>
  )
}
